import { Component, Input } from "@angular/core";

@Component({
    selector: 'dynamic-analytics-chart',
    templateUrl: './dynamic-analytics-chart.html',
    standalone: false
})
export class DynamicChartComponent {
    @Input() chartType : string | null = null;
    @Input() startDate: Date | null = null;
    @Input() endDate: Date | null = null;

    constructor() {
    }
    // Alternatively, you can use ngOnInit if you only need to run code once when the component is initialized
    ngOnInit(): void {
    }
}